import { Text } from '@ksyos/design-system';
import { ServiceCode } from '../../../../../common/enums/serviceCode';
import { GgzConsultationPersonalSettings } from './GgzConsultationPersonalSettings';
import { GgzExaminationPersonalSettings } from './GgzExaminationPersonalSettings';

export interface IGgzPersonalSettingsCustomControlProps {
    employmentId: string;
    isReadOnly: boolean;
    serviceConsumerId: string;
}

type CustomControl = (props: IGgzPersonalSettingsCustomControlProps) => JSX.Element | null;

const mentalHealthServiceSettingComponents = new Map<ServiceCode, CustomControl>([
    [ServiceCode.GGZCt, GgzConsultationPersonalSettings],
    [ServiceCode.GGZOint, GgzExaminationPersonalSettings],
    [ServiceCode.GGZOembl, GgzExaminationPersonalSettings],
]);

export function hasMentalHealthServiceSettingComponent(serviceCode: ServiceCode) {
    return mentalHealthServiceSettingComponents.has(serviceCode);
}

export function loadMentalHealthServiceSettingCustomControl(serviceCode: ServiceCode): CustomControl {
    const customControl = mentalHealthServiceSettingComponents.get(serviceCode);
    if (!customControl) {
        return () => <Text>{`Cannot find custom control for ${serviceCode}`}</Text>;
    }

    return customControl;
}
